import React from "react";

function Failure() {
  return (
    <div>
      <h3>Adding card failure!!!</h3>
    </div>
  );
}

export default Failure;
